<div class="row" cdkDropListGroup>
    <div class="col-sm-3 mt-2">
        <h5>Usuarios</h5>
        <ul class="list-group list-group mt-1 min-role-size">
            <li [ngClass]="{'selectedRole' : user.IsSelected}" class="list-group-item item-hover"
                *ngFor="let user of users" [id]="user.Id" (click)="SelectUser(user)"> {{user.Email}}
            </li>
        </ul>
    </div>
    <div class="col-sm-4 mt-2">
        <h5>Roles asociados</h5>
        <div cdkDropList [cdkDropListData]="assignedRoles" class="example-list"
            (cdkDropListDropped)="drop($event, false)">
            <div class="example-box item-hover" *ngFor="let item of assignedRoles" cdkDrag>{{item.Name}}
            </div>
        </div>
    </div>
    <div class="col-sm-1 mt-2">
        <h6>&nbsp;</h6>
        <button class="btn btn-sm btn-light btn-st shadow btn-block" (click)="OffsetRoles(0)">
            <i class="fa fa-arrow-right" aria-hidden="true"></i>
        </button>
        <br>
        <button class="btn btn-sm btn-light btn-st shadow btn-block" (click)="OffsetRoles(1)">
            <i class="fa fa-arrow-left" aria-hidden="true"></i>
        </button>
    </div>
    <div class="col-sm-4 mt-2">
        <h5>Roles disponibles</h5>

        <div cdkDropList [cdkDropListData]="roles" class="example-list"
            (cdkDropListDropped)="drop($event, false)">
            <div class="example-box item-hover" *ngFor="let role of roles" cdkDrag>{{role.Name}}</div>
        </div>

    </div>
</div>
